import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/projects/new/chatId/page';

export const Route = createFileRoute('/_app/_chat/projects/new/$chatId/')({
  component: Page,
});
